module.exports = __webpack_public_path__ + "static/media/onecask.63415ef9.png";